export interface BookkeepingFilterType {
  selectedBookkeepings: server.dto.BookkeepingSmall[]
  initialBookkeepings: server.dto.BookkeepingSmall[]
}

export const getSortedBookkeepings = (filter: BookkeepingFilterType) => {
  return filter.selectedBookkeepings.map(b => `${b.name} (${b.code})`)
    .sort((a, b) => a.localeCompare(b));
};

export const initialBookkeepingFilter: BookkeepingFilterType = {
  selectedBookkeepings: [],
  initialBookkeepings: []
};